__webpack_require__.p = "https://www.equalize.team/";